import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcular'
})
export class CalcularPipe implements PipeTransform {
  transform(precioVenta: number, precioNormal?: number, cantidad?: number, check?: boolean): number {
    if (check) { // Check===true Subtotal 0
      return 0.01 * cantidad;
    } else {
      if (precioNormal > precioVenta && precioVenta !== null) {
        return precioNormal * cantidad;
      } else {
        return precioVenta * cantidad;
      }
    }
  }
}
